<template>
  <div>
    <div>
      <div style="background-color: white;overflow:hidden;">
        <div>
          <van-icon name="arrow-left" style="float: left;margin-top: 15px;margin-left: 15px" @click="onClick()"/>
          <h1 class="g-hd">
            {{ this.returnNo }}
          </h1>
          <div style="background-color: white;">
            <van-button type="primary" size="small" round color="#2985F2"
                        style="float: right;margin-right:5px;margin-top: 10px"
                        :to="'orderReturnStep?returnNo='+returnNo">{{ orderReturnItem.status }}
            </van-button>
          </div>
          <div style="height: 10px">
            <label class="Specifications1">澳洋医院-{{ orderReturnItem.createBy }}</label>
          </div>
          <div style="margin-right: 5px">
            <van-tag class="byRight" type="primary" text-color="#AFEEEE">{{ orderReturnItem.type }}</van-tag>
          </div>
        </div>
      </div>
      <!--当退货单是“待提交”时,显示医院的药品信息,其他状态则显示审批通过和审批驳回的信息-->
      <div v-if="status == '待提交' || status == 'OA审批中'">
        <van-pull-refresh v-model="isLoading" success-text="刷新成功" @refresh="onRefresh(true)">
          <orderReturnDetail_body ref="orderReturnDetail_body" :isPass="all" :status="status"
                                  @func="setBtnText"></orderReturnDetail_body>
        </van-pull-refresh>
      </div>
      <div v-else style="margin-bottom: 80px">
        <van-tabs sticky color="#429EF5">
          <van-tab title="审批通过" name="a">
            <van-pull-refresh v-model="isLoading" success-text="刷新成功" @refresh="onRefresh(true)">
              <orderReturnDetail_body ref="orderReturnDetail_body" :isPass="agree" :status="status"
                                      @func="setBtnText"></orderReturnDetail_body>
            </van-pull-refresh>
          </van-tab>
          <van-tab title="审批驳回" name="b">
            <van-pull-refresh v-model="isLoading" success-text="刷新成功" @refresh="onRefresh(true)">
              <orderReturnDetail_body ref="orderReturnDetail_body" :isPass="pass" :status="status"
                                      @func="setBtnText"></orderReturnDetail_body>
            </van-pull-refresh>
          </van-tab>
        </van-tabs>
      </div>
      <div class="ToolBar">
        <van-button style="margin-top: 30px;width: 250px" type="info" round
                    color="linear-gradient(to right, #1C7BEF, #60B2FE)" @click="sure()">{{ btnText }}
        </van-button>
      </div>
      <!--悬浮按钮-->

    </div>
  </div>
</template>

<script>
import api from "@/axios/api";
import {mapGetters, mapActions} from "vuex";
import orderReturnDetail_body from "@/spd/orderReturnDetail_body";
import {Notify} from 'vant';
import {Toast} from 'vant';


export default {
  computed: {
    ...mapGetters(["token"])
  },
  watch: {
    token: {
      immediate: true,
      handler: function (val) {
        this.returnNo = this.$route.query.returnNo;
        this.status = this.$route.query.status;
        //this.getOrderReturnItems(this.returnNo);
        if (val) {
          this.getOrderReturnItems(this.returnNo);
        }
      }
    }
  },
  components: {
    orderReturnDetail_body
  },
  data() {
    return {
      returnNo: '',
      storageMode: [],
      orderReturnItem: [],
      btnText: "",
      isLoading: false,
      agree: "0",
      pass: "1",
      all: "-1",
      status:"",
      statusList:["待提交","OA审批中"],
      /*悬浮按钮*/

    }
  },
  mounted() {

  },
  created() {
  },
  methods: {
    onClick() {
      this.$router.replace('/spd/orderReturnList');
    },

    getOrderReturnItems() {
      let params = {
        returnNo: this.returnNo
      };
      api.getOrderReturnByReturnNo(params).then((res) => {
        if (res.success) {
          this.orderReturnItem = res.result;
          this.status = this.orderReturnItem.status;
        } else {
          Notify(res.message);
        }
      })
    },
    sure() {
      if (this.btnText == "确定") {
        Notify("该退货单无药品数据或正在审批中！");
      } else {
        let params = {
          returnNo: this.returnNo
        }
        api.userSure(params).then((res) => {
          if (res.success) {
            Toast.success(res.message);
            this.onRefresh(true);
          } else {
            Toast.fail(res.message);
          }
        })
      }
    },
    //为按钮赋值
    setBtnText(data) {
      this.btnText = data
    },
    onRefresh(flag) {
      setTimeout(() => {
        if (flag) {
          //清空列表数据
          this.$refs.orderReturnDetail_body.orderReturnDetailItems = [];
          this.$refs.orderReturnDetail_body.getOrderDetailByReturnNo();
          this.isLoading = false;
          this.count++;
        } else {
          //清空列表数据
          this.$refs.orderReturnDetail_body_pass.orderReturnDetailItems = [];
          this.$refs.orderReturnDetail_body_pass.getOrderDetailByReturnNo();
          this.isLoading = false;
          this.count++;
        }

      }, 1000);
    },

  }
}
</script>

<style scoped>
.clear {
  clear: both;
}

.g-hd {
  display: inline;
  float: left;
  font-size: 20px;
  font-weight: lighter;
  font-style: normal;
  color: #3C8EF2;
  background-color: white;
  margin-left: 3%;
  overflow: hidden;
}

.Specifications1 {
  clear: both;
  float: left;
  margin-left: 3%;
  font-size: 80%;
  color: #686464;
}

.ToolBar {
  position: fixed;
  bottom: 0px;
  width: 100%;
  height: 80px;
  text-align: center;
  z-index: 1;
  background-color: white;
}

.byRight {
  float: right;
  margin-right: 1%;
  margin-top: 1%;
}

.van-tag--danger {
  background-color: #429EF5;
  height: 15px;
  clear: both;
}

.custom-title {
  margin-right: 2px;
  vertical-align: middle;
}


* { touch-action: pan-y; }

</style>



// WEBPACK FOOTER //
// src/spd/orderReturnDetail.vue